import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ICostCenter } from '@api/types'
import { CostCenterFragment } from '@api/fragments'

interface Payload {
  data: {
    viewer: {
      company: {
        costCenters: ICostCenter[]
      }
    }
  }
}

export default function costCenters(): Promise<ICostCenter[]> {
  return client.gql.query({ query }).then(
    ({
      data: {
        viewer: {
          company: { costCenters },
        },
      },
    }: Payload) => costCenters
  )
}

const query = gql`
  query costCenters {
    viewer {
      company {
        costCenters {
          ...CostCenterFragment
        }
      }
    }
  }
  ${CostCenterFragment}
`
